import { useState } from "react";
import { Link } from "react-router-dom";
import { BadgeCheck, Clock, Lock } from "lucide-react";
import SaveButton from "./SaveButton";

export const formatDiscount = (o) => {
    if (o.discountValue && o.discountType === "percentage") return `${o.discountValue}% OFF`;
    if (o.discountValue) return `₹${o.discountValue} OFF`;
    return o.discountType === "code" ? "COUPON" : "DEAL";
};

export const BrandLogo = ({ brand, className = "h-10 w-10" }) => {
    const [err, setErr] = useState(false);
    const name = brand?.name || "?";
    if (!brand?.logo || err)
        return (
            <span className={`flex shrink-0 items-center justify-center rounded-xl bg-india/10 font-display text-sm font-semibold text-india ${className}`}>
                {name.charAt(0).toUpperCase()}
            </span>
        );
    return (
        <img
            src={brand.logo}
            alt={name}
            loading="lazy"
            onError={() => setErr(true)}
            className={`shrink-0 rounded-xl border border-ink/5 bg-white object-contain p-1 ${className}`}
        />
    );
};

export const OfferCard = ({ offer, className = "" }) => (
    <Link
        to={`/offers/${offer.id}`}
        data-testid={`offer-card-${offer.id}`}
        className={`group flex flex-col rounded-2xl border border-ink/5 bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${className}`}
    >
        <div className="flex items-center gap-3">
            <BrandLogo brand={offer.brand} />
            <div className="flex min-w-0 items-center gap-1.5">
                <span className="truncate text-xs font-medium uppercase tracking-wide text-smoke">
                    {offer.brand?.name}
                </span>
                {offer.isVerified && <BadgeCheck className="h-3.5 w-3.5 shrink-0 text-leaf" />}
            </div>
            <span className="ml-auto flex shrink-0 items-center gap-1.5">
                {offer.locked && <Lock className="h-4 w-4 text-saffron" aria-label="Member only" />}
                <SaveButton kind="offer" id={offer.id} />
            </span>
        </div>
        <h3 className="mt-4 line-clamp-2 flex-1 font-display text-base font-medium leading-snug tracking-tight text-ink">
            {offer.title}
        </h3>
        <div className="mt-4 flex items-center justify-between gap-2">
            <span className="rounded-full bg-saffron-soft px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-wider text-saffron">
                {formatDiscount(offer)}
            </span>
            {offer.expiringSoon && offer.daysLeft != null && (
                <span className="flex items-center gap-1 text-[11px] font-medium text-smoke">
                    <Clock className="h-3 w-3" />
                    {offer.daysLeft <= 0 ? "Ends today" : `${offer.daysLeft}d left`}
                </span>
            )}
        </div>
    </Link>
);
